// Finestra separata per scrivere una mail: /scrivi?draft=ID (oppure to/subject)
export const MAIL_REFRESH_KEY = "crm_mail_refresh";

export function openComposerWindow(params = {}) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v) q.set(k, v); });
  const w = Math.min(980, window.screen.availWidth - 60);
  const h = Math.min(900, window.screen.availHeight - 60);
  const win = window.open(
    `/scrivi?${q.toString()}`, `scrivi-${params.draft || "nuova"}`,
    `popup=yes,width=${w},height=${h},left=${Math.max(0, (window.screen.availWidth - w) / 2)},top=40`,
  );
  if (win) win.focus();
  return win;
}

// avvisa le altre schede/finestre che le bozze o gli inviati sono cambiati
export function notifyMailChanged() {
  try { localStorage.setItem(MAIL_REFRESH_KEY, String(Date.now())); } catch (_) { /* ignora */ }
}

// si iscrive agli avvisi delle altre finestre (ritorna la funzione di pulizia)
export function onMailChanged(cb) {
  const h = (e) => { if (e.key === MAIL_REFRESH_KEY) cb(); };
  window.addEventListener("storage", h);
  return () => window.removeEventListener("storage", h);
}
